import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'pas-access-denied',
  standalone: true,
  imports: [],
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccessDeniedComponent implements OnInit {
  router = inject(Router);

  async login() {
    await this.router.navigate(['/login']);
  }

  ngOnInit(): void {
    setTimeout(() => this.login(),6000);
  }


}
